import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { spacer32, Type } from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';
import {
  AppearsOnPaginationContext,
  ArtistAlbum,
} from '@hooks/useArtistAppearsOn/types';
import { RenderPaginationProps } from '@hooks/usePagination';
import { ReleasesTable } from '../Releases/ReleasesTable';

const SubtitleContainer = styled.div`
  margin-bottom: ${spacer32};
`;

interface AppearsOnProps {
  albums: ArtistAlbum[];
  artistName: string;
  isLoading: boolean;
  isError: boolean;
  paginationProps?: {
    appearsOnPaginationContext: AppearsOnPaginationContext;
    renderArtistAppearsOnPagination: (
      renderArtistAppearsOnPaginationProps: RenderPaginationProps,
    ) => JSX.Element;
  };
}

export const AppearsOn = ({
  albums,
  artistName,
  isLoading,
  isError,
  paginationProps,
}: AppearsOnProps) => {
  const t = useT();
  const hasResults = albums.length > 0;

  return (
    <>
      {hasResults && !isError && !isLoading && (
        <>
          <SubtitleContainer>
            <Type variant="viola">
              {t(
                'atlas.artist.appears_on_subtext',
                '{artistName} appears on releases below as a Main artist, Featured artist, Remixer, or Actor on track level only.',
                'Indicates empty state',
                { artistName },
              )}
            </Type>
          </SubtitleContainer>
        </>
      )}
      <ReleasesTable
        variant="appearsOn"
        showEmptyState={!isLoading && !isError && isEmpty(albums)}
        albums={albums}
        isLoading={isLoading}
        isError={isError}
        paginationProps={
          paginationProps
            ? {
                paginationContext: paginationProps.appearsOnPaginationContext,
                renderPagination:
                  paginationProps.renderArtistAppearsOnPagination,
              }
            : undefined
        }
      />
    </>
  );
};
